<payee-popup>
  <ng-template #payeePopupTitleTemplate>
    <payee-icon
      name="trash-black"
      class="title-icon"
      height="73px"
      width="auto"
    ></payee-icon>
    <h1>Biztosan elveti a piszkozatot?</h1>
  </ng-template>

  <ng-template #payeePopupDescriptionTemplate>
    <span class="description">
      Az eddig megadott adatok véglegesen elvesznek.
    </span>
  </ng-template>

  <ng-template #payeePopupSubmitTemplate>
    <button
      class="payee-button"
      payee-button
      color="alert-red"
      width="wide"
      height="normal"
      [mat-dialog-close]="true"
    >
      <ng-container>Elvetem</ng-container>
    </button>
  </ng-template>

  <ng-template #payeePopupCancelTemplate>
    <button
      class="payee-button"
      payee-button
      [isBorderButton]="true"
      [mat-dialog-close]="false"
      color="white"
      width="wide"
      height="normal"
    >
      <ng-container>Mégsem</ng-container>
    </button>
  </ng-template>
</payee-popup>
